var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-page',{key:"home",staticClass:"flex flex-center row home-bg",staticStyle:{"padding-top":"2%"}},[_c('HomeCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }